import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { siteInfo } from '@/mocks/home';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-18">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
            <div className="md:col-span-5">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-book-2-line text-2xl text-accent-500"></i>
                </div>
                <span className="font-heading text-2xl font-bold text-background-50">
                  {siteInfo.name}
                </span>
              </div>
              <p className="text-foreground-300 text-sm leading-relaxed max-w-sm mb-6">
                {siteInfo.description}
              </p>
              <div className="flex items-center gap-4">
                {[
                  { icon: 'ri-weibo-line', href: siteInfo.socialLinks.weibo, label: '微博' },
                  { icon: 'ri-wechat-line', href: siteInfo.socialLinks.wechat, label: '微信' },
                  { icon: 'ri-bilibili-line', href: siteInfo.socialLinks.bilibili, label: 'B站' },
                  { icon: 'ri-red-packet-line', href: siteInfo.socialLinks.xiaohongshu, label: '小红书' },
                ].map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="w-10 h-10 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-accent-500 hover:border-accent-500 transition-colors duration-200"
                    aria-label={social.label}
                  >
                    <i className={`${social.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
                  </a>
                ))}
              </div>
            </div>

            <div className="md:col-span-3">
              <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5 font-label">
                联系方式
              </h4>
              <div className="space-y-5">
                <div>
                  <p className="text-xs text-foreground-500 mb-1">公司地址</p>
                  <p className="text-sm text-foreground-200 leading-relaxed">{siteInfo.address}</p>
                </div>
                <div>
                  <p className="text-xs text-foreground-500 mb-1">客服电话</p>
                  <p className="text-sm text-foreground-200">{siteInfo.phone}</p>
                </div>
                <div>
                  <p className="text-xs text-foreground-500 mb-1">商务邮箱</p>
                  <p className="text-sm text-foreground-200">{siteInfo.email}</p>
                </div>
              </div>
            </div>

            <div className="md:col-span-4">
              <div className="w-full h-40 md:h-full rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Chinese%20manga%20illustration%20art%20wall%2C%20beautiful%20ink%20wash%20painting%20style%20landscape%20with%20cherry%20blossoms%20and%20distant%20mountains%2C%20soft%20warm%20tones%2C%20traditional%20Chinese%20art%20aesthetic%2C%20decorative%20manga%20panel%20background%2C%20clean%20composition&width=500&height=350&seq=footer-manga-art-01&orientation=landscape"
                  alt="布丁漫画网艺术插图"
                  title="布丁漫画网 - 发现好漫画"
                  className="w-full h-full object-cover object-top rounded-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800/60">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              {t('common:footer_copyright')}
            </p>
            <div className="flex items-center gap-6">
              <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">
                {t('common:footer_privacy')}
              </Link>
              <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">
                {t('common:footer_terms')}
              </Link>
              <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">
                {t('common:footer_contact')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}